import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconArrowBothComponent } from "./med-icon-arrow-both.component";

@NgModule({
  declarations: [
    MedIconArrowBothComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconArrowBothComponent,
  ],
})
export class MedIconArrowBothModule { }
